import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_d_control_recaptcha = _resolveComponent("d-control-recaptcha")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_d_control_recaptcha, {
      class: "control-descriptor--clear",
      ref: "captchaRef",
      onVerify: _cache[0] || (_cache[0] = ($event: any) => ($setup.saveCaptcha($event)))
    }, null, 512),
    _renderSlot(_ctx.$slots, "default", {
      is_confirmed: $setup.is_confirmed,
      sendCode: force => $setup.validate(force),
      openModal: $setup.openModal
    })
  ]))
}